/**
 * 路由相关常量
 */

export const ROUTE_TITLES = {
  LANDING: '智慧校园排课系统',
  LOGIN: '登录'
} as const

/** 运营控制台（控制面，与租户业务入口逻辑分离） */
export const OPS_ROUTE_TITLES = {
  LOGIN: '运营登录',
  TENANTS: '租户管理',
  AI_SKILLS: 'AI 技能',
  AI_MODELS: 'AI 模型',
  MODEL_CONTEXT_CATALOG: '窗口目录'
} as const

export const ERROR_PAGE_TEXT = {
  NOT_FOUND_CODE: '404',
  NOT_FOUND_MESSAGE: '抱歉，您访问的页面不存在',
  NOT_FOUND_TITLE: '页面不存在',
  BACK_HOME_BUTTON: '返回首页'
} as const

export const APP_NAME = '智慧校园'

export const APP_FULL_NAME = '智慧校园系统'

// 登录后的默认落地页：新版导航工作台。
export const DEFAULT_REDIRECT_PATH = '/next/workbench'
